import { Link } from 'wouter';

export default function NotFound() {
  return (
    <section className="bg-ink text-white">
      <div className="mx-auto max-w-prose px-6 py-40 text-center">
        <span className="rr-tag">// 404</span>
        <h1 className="mt-4 text-display-md font-bold tracking-headline text-white">
          Page not found.
        </h1>
        <p className="mt-3 text-base text-ash">
          The page you&apos;re looking for doesn&apos;t exist or has moved.
        </p>
        <Link
          href="/"
          className="mt-10 inline-flex items-center rounded-pill border border-ink-3 bg-ink-2 px-5 py-2.5 text-sm font-medium text-white hover:border-signal/50"
        >
          Back to homepage
        </Link>
      </div>
    </section>
  );
}
